<template>
  <el-dialog :visible.sync="visible" :title="title" :close-on-click-modal="false"
             :close-on-press-escape="false" width="80%">
    <SweetTable ref="table" url="/erp/settle/material/receive/list" :height="500" :query-form="queryForm" :summaries-column="['count']" :before-table-binding="beforeTableBinding" :auto-load="false"
                :is-page="false">
      <el-table-column
          prop="storageName"
          label="工厂名称"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="count"
          label="数量"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <div :style="{color:row.type===-1?'#F56C6C':''}">{{row.count}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="reason"
          label="原因"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  name: 'material-receive-list',
  mixins: [SweetTable],
  data () {
    return {
      visible: false,
      materialInfo:{},
      queryForm: {
        storageId: null,
        productId: null,
        agreementId: null,
      }
    }
  },
  computed:{
    title(){
      let tmp=[this.materialInfo.name,this.materialInfo.color,this.materialInfo.size,this.materialInfo.attr1,this.materialInfo.attr2]
      return '物料收货明细【'+tmp.join(' ')+'】'
    }
  },
  methods: {
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
        row.count=new BigNumber(row.count).multipliedBy(row.type)
      })
    },
    init (factoryId, materialId, orderId) {
      this.queryForm = {
        storageId: factoryId,
        productId: materialId,
        agreementId: orderId
      }
      this.reload()
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>
